import { HttpClient } from '@angular/common/http';
import { Injector, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ValidacaoService {

    protected http: HttpClient;

    constructor(protected injector: Injector) {
        this.http = injector.get(HttpClient);
    }

    validarRequisitos(estimativaId: number): Observable<boolean> {
        return this.http.get<boolean>(`${environment.API_PRICE}/validar/requisitos/${estimativaId}`);
    }

    validarComposicaoEquipe(estimativaId: number): Observable<boolean> {
        return this.http.get<boolean>(`${environment.API_PRICE}/validar/composicao-equipe/${estimativaId}`);
    }

    validarCronogramaEstimativa(estimativaId: number): Observable<boolean> {
        return this.http.get<boolean>(`${environment.API_PRICE}/validar/cronograma-estimativa/${estimativaId}`);
    }

    validarParametros(estimativaId: number): Observable<boolean> {
        return this.http.get<boolean>(`${environment.API_PRICE}/validar/parametros/${estimativaId}`);
    }

    validarEnvioAprovacao(estimativaId: number): Observable<any> {
        return this.http.get<any>(`${environment.API_PRICE}/validar/enviar-aprovacao/${estimativaId}`);
    }
}
